module.exports = __webpack_public_path__ + "static/media/GeorgiaPacific.5d8e0215.svg";